export default __webpack_public_path__ + "static/partnerColorIcon13-2b61d8f95145ac19595c9a084d091e47.svg";